import { sendEventRegist } from 'helpers/analytics';
import { getChannelContextCode } from 'helpers/Utility';
import { setError, setPhoneNo } from 'store/actions/auth';
import { setApplicationStatus } from 'store/actions/loanApply';

const handleNumberNotRegistered = (
  err,
  dispatch,
  haveAccount,
  action,
  phoneNo,
  history
) => {
  if (getChannelContextCode(err, 'channel-context') === '120000')
    return dispatch(setError('system'));

  if (haveAccount) return action?.();

  dispatch(setPhoneNo(phoneNo));
  localStorage.removeItem('phoneNo', phoneNo);

  sendEventRegist({
    action: 'User Regist the Number',
    label: 'phone number'
  });

  dispatch(setApplicationStatus(''));
  history.push('/create-pin');
};

const handleNumberAlreadyRegistered = (
  err,
  dispatch,
  haveAccount,
  action,
  phoneNo,
  history
) => {
  const codeNumberAlreadyRegistered = ['4090101', '107880'];

  if (
    codeNumberAlreadyRegistered.includes(
      getChannelContextCode(err, 'channel-context')
    )
  ) {
    if (haveAccount) {
      dispatch(setPhoneNo(phoneNo));
      dispatch(setApplicationStatus('FRESH_START'));
      return history.push('/login');
    }
    return action?.();
  }

  if (getChannelContextCode(err, 'channel-context') === '211096') {
    return dispatch(setError('have-change-number'));
  }

  dispatch(setError('system'));
};

const navigateAccountDeleted = (phoneNo, history) => {
  history?.push({
    pathname: '/account-deleted',
    state: { phoneDeleted: phoneNo }
  });
};

/**
 * Main function to handle phone registration error
 * @param {Object} err - Error object
 * @param {Number} status - HTTP status code
 * @param {Function} dispatch - Redux dispatch function
 * @param {*} haveAccount
 * @param {*} action
 * @param {*} phoneNo
 * @returns
 */
export const handleErrorPhoneRegistration = (
  err,
  status,
  dispatch,
  haveAccount,
  action,
  phoneNo,
  history
) => {
  // 1. Account deleted
  if (
    getChannelContextCode(err, 'channel-context') === '24037' ||
    getChannelContextCode(err, 'channel-context') === '4030001'
  )
    return navigateAccountDeleted(phoneNo, history);

  // 2. ERR_NETWORK
  if (err.code === 'ERR_NETWORK') {
    return dispatch(setError('connection'));
  }

  // 3. Missing channel context
  if (getChannelContextCode(err, 'channel-context') === null)
    return dispatch(setError('system'));

  // 4. status 401 → number not registered
  if (status === 401)
    return handleNumberNotRegistered(
      err,
      dispatch,
      haveAccount,
      action,
      phoneNo,
      history
    );

  // 5. status 400 → number already registered
  if (status === 400 || status === 409)
    return handleNumberAlreadyRegistered(
      err,
      dispatch,
      haveAccount,
      action,
      phoneNo,
      history
    );

  // fallback
  dispatch(setError('system'));
};
